import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css/core';

class AutoMovingSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    // this.len = this.dom.slider.querySelectorAll('.splide__slide').length;

    this.slider = null;
    this.option = {
      autoScroll: {
        speed: .5,
      },
      autoWidth: true,
      pagination: false,
      arrows: false,
      pauseOnHover: false,
      type: 'loop',
      drag: false,
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount({ AutoScroll });
  }
  
  play() {
    this.slider.Components.Autoplay.play();
  }
}

export default AutoMovingSlides